import { Component, Input, OnInit } from '@angular/core';
import { LocalStorageService } from '../_services/local-storage.service';
import { LoginService } from '../_services/login.service';
import * as _ from 'underscore';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { PersonSearchService } from '../_services/person-search.service';
import { AggregationService } from '../_services/aggregation.service';
declare const clevertap;

@Component({
    selector: 'app-save-search-persmission-modal',
    templateUrl: './save-search-persmission-modal.component.html',
    styleUrls: ['./save-search-persmission-modal.component.scss'],
    standalone: false
})
export class SaveSearchPersmissionModalComponent implements OnInit {

  currentUserId: string= null;
  allTeamMembers: any[] = [];
  shareErrorMessage: string= null;
  selectedMembers: any[] = [];
  @Input() saveSearchName: string = null;
  @Input() saveSearchId: number = null;
  revokedMembers: any[] = [];
  constructor(private loginService: LoginService, private localstorageService: LocalStorageService, private activeModal: NgbActiveModal,
    private personService: PersonSearchService, private aggregationService: AggregationService) { }

  ngOnInit() {
    this.getAllTeamMembers();
    this.currentUserId = this.localstorageService.getItem('userid');

  }

  getAllTeamMembers() {
    this.loginService.getTagUsers('').subscribe((res: any) => {
      if(res && res.status === 'success') {
        const allMembers: any[] = res?.message || [];
        this.allTeamMembers = allMembers.filter(mem => mem.userid != this.currentUserId).map(mem => ({ ...mem, selected: false }));
        this.getExistingSaveSearches();
      }
    })
  }

  changeMemberSelection(event, member) {
    this.shareErrorMessage = '';
    const checked = (event.target as HTMLInputElement).checked;
    member.selected = checked;
    if(checked) {
      this.selectedMembers.push(member);
    } else {
      this.selectedMembers = this.selectedMembers.filter(mem => mem.userid != member.userid);
      this.revokedMembers.push(member.userid);
    }
    this.selectedMembers = _.uniq(this.selectedMembers, 'userid');
  }

  closeModal(type: string, message?: any) {
    if(type == 'error') {
      this.activeModal.dismiss(message);
    } else {
      this.activeModal.close(type == 'skip' ? 'user-dismissed' : message ? message : null);
    }
  }

  getExistingSaveSearches() {
    this.personService.getSharedSavedSearches({savedsearches: [this.saveSearchId]}).subscribe((res:any) => {
      if(res && res.status === 'success') {
        const saveShareInfo: any[] = res?.data?.shareInfo || [];

        this.allTeamMembers = this.allTeamMembers.map(mem => {
          const present = saveShareInfo.some((mapping: any) => mapping.sharedwith === mem.userid );
          if( present) {
            mem.selected = true;
            this.selectedMembers.push(mem);
          }
          return {...mem, shareMappingActive: !!mem.selected};

        })
      }
    }, (err: any) => {
      console.log("[getExistingShareInfoForTalentpools error] SharedTalentpoolsListingComponent - ", err);
    })
  }

  shareSavedSearches() {
    const granted = this.allTeamMembers.filter(mem => !mem.shareMappingActive && mem.selected).map(mem => mem.userid);
    const revoked =  this.revokedMembers;//this.allTeamMembers.filter(mem => mem.shareMappingActive && !mem.selected).map(mem => mem.userid);
    const disableShareButton = granted.length == 0 && revoked.length == 0;
    this.shareErrorMessage = disableShareButton ? 'Please select or deselect at least one member to share the save search.' : '';
    if(disableShareButton) return;
    const payload = {
      savedsearches: [this.saveSearchId],
      grant: granted,
      revoke: revoked
    }

    this.personService.shareSavedSearch(payload).subscribe((res:any) =>{
      if(res && res.status === 'success') {
            /**
           * share search CT event
           */
             const saveSearchParams = {
              "User ID": this.localstorageService.getItem('userdata').userid,
              "Search Name": this.saveSearchName,
              "Shared to ID": granted.toString(),
              "Filters Applied": JSON.stringify(this.aggregationService.getRequestWithFilters())
            }
            clevertap.event.push('Share Search', saveSearchParams);
            this.closeModal('success', `Search shared successfully to user`);

      } else {
        this.closeModal('error');
      }
    }, (err: any) => {
      this.closeModal('error', 'Something went wrong');
    });

  }
}
